interface CartItem {
  id: number;
  quantity: number;
  variationId?: number;
}

interface UserData {
  email?: string;
  first_name?: string;
  last_name?: string;
}

export async function syncCartToWooCommerce(
  items: CartItem[],
  userData?: UserData,
  wcCustomerId?: number | null,
  queryParams?: Record<string, string>
): Promise<string | null> {
  const wpUrl = process.env.NEXT_PUBLIC_WP_URL || '';
  if (!wpUrl) {
    console.error('WooCommerce URL non configurato');
    return null;
  }

  if (!items || items.length === 0) {
    console.warn('Nessun prodotto da sincronizzare');
    return null;
  }

  const item = items[0];
  
  try {
    // Invia i dati via POST invece di GET
    const response = await fetch('/api/shop/initiate-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: item.id,
        quantity: item.quantity,
        variationId: item.variationId,
        billingEmail: userData?.email,
        billingFirstName: userData?.first_name,
        billingLastName: userData?.last_name,
        wcCustomerId: wcCustomerId,
        queryParams: queryParams || {}
      })
    });

    if (!response.ok) {
      console.error('Errore durante l\'inizializzazione del checkout');
      return null;
      }

    const result = await response.json();
    if (result.success && result.checkoutUrl) {
      return result.checkoutUrl;
    }
    
    return null;
  } catch (error) {
    console.error('Errore durante la chiamata API:', error);
    return null;
  }
}
